// Pure helpers answering "is this stored JWT still usable?". The route guards
// and the impersonation banner both need the same judgment: a token whose
// `exp` has passed must be treated exactly like no token at all — render the
// visitor as logged out — never allowed through to fire authenticated calls
// that 401 and bounce the browser between apps.
import { jwtDecode } from 'jwt-decode';
import { IPayload } from '@shared/interfaces/payload.interface';

// A missing `exp` also counts as expired: the API stamps one on every token
// it issues, so its absence means a mangled or foreign token — and treating
// it as live would give the impersonation banner a NaN countdown that never
// fires.
export function isJwtExpired(exp: number | undefined | null): boolean {
  return !exp || exp <= Math.floor(Date.now() / 1000);
}

// Decode a stored token and return its payload only when it is well-formed
// and unexpired; null otherwise (including tokens jwt-decode cannot parse —
// a corrupt cookie must not crash a guard into a white screen).
export function decodeUsableToken(token: string): IPayload | null {
  let payload: IPayload;
  try {
    payload = jwtDecode<IPayload>(token);
  } catch {
    return null;
  }
  return isJwtExpired(payload.exp) ? null : payload;
}
